import { Alert, Button, PageHeader, SkeletonRows } from "@station/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { AccountingPage, companySearchShape } from "../../../../../features/accounting/company.js";
import { EntryEditor } from "../../../../../features/accounting/entry-editor.js";
import { useJournalEntry } from "../../../../../features/accounting/shared.js";
import { errorMessage } from "../../../../../lib/errors.js";
import { useDocumentTitle } from "../../../../../lib/hooks.js";

export const Route = createFileRoute("/_app/muhasebe/fisler/$id/duzenle")({
  validateSearch: (search) => z.object(companySearchShape).parse(search),
  component: EditEntryPage,
});

function EditEntryPage() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const entry = useJournalEntry(id);
  useDocumentTitle(t("accounting.entry.editTitle"));

  if (!entry.data)
    return (
      <>
        <PageHeader
          title={t("accounting.entry.editTitle")}
          breadcrumb={[{ label: t("menu.groups.accounting") }, { label: t("menu.journalEntries") }]}
        />
        {entry.error ? <Alert tone="danger">{errorMessage(entry.error)}</Alert> : <SkeletonRows rows={8} />}
      </>
    );

  const data = entry.data;
  return (
    <AccountingPage
      fixedCompanyId={data.companyId}
      title={t("accounting.entry.editTitle")}
      description={t("accounting.entry.description")}
      breadcrumb={[
        {
          label: t("menu.journalEntries"),
          link: (children, className) => (
            <Link to="/muhasebe/fisler" className={className}>
              {children}
            </Link>
          ),
        },
        { label: t("accounting.entry.editTitle") },
      ]}
    >
      {() =>
        data.status === "DRAFT" ? (
          // Anahtar yalnızca kimliktir: kayıt sonrası sürüm değişse de form yeniden kurulmaz (yazılanlar korunur).
          <EntryEditor key={data.id} entry={data} mode="edit" />
        ) : (
          <Alert tone="warning" title={t("accounting.entry.notEditableTitle")}>
            <p>{t("accounting.entry.notEditable")}</p>
            <Button asChild size="sm" variant="outline" className="mt-2">
              <Link to="/muhasebe/fisler/$id" params={{ id: data.id }}>
                {t("accounting.entry.backToDetail")}
              </Link>
            </Button>
          </Alert>
        )
      }
    </AccountingPage>
  );
}
